import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZoomIn = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.7593 6.80289C11.7594 7.7832 11.4688 8.74153 10.9243 9.55668C10.3797 10.3718 9.60564 11.0072 8.69997 11.3824C7.79429 11.7576 6.7977 11.8558 5.83621 11.6646C4.87473 11.4733 3.99154 11.0013 3.29836 10.3081C2.60517 9.6149 2.13311 8.73172 1.94189 7.77023C1.75067 6.80875 1.84886 5.81215 2.22406 4.90648C2.59927 4.00081 3.23461 3.22674 4.04976 2.68217C4.86491 2.1376 5.82324 1.847 6.80356 1.84711C8.11787 1.84725 9.37831 2.36942 10.3077 3.29878C11.237 4.22814 11.7592 5.48858 11.7593 6.80289Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.30859 6.76898H9.23047",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.76953 9.22992V4.30804",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.3076 10.3073L14.1516 14.1518",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgZoomIn;
